import { render } from "./sysTenantTCol.vue?vue&type=template&id=7393d950"
import script from "./sysTenantTCol.vue?vue&type=script&lang=js"
export * from "./sysTenantTCol.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__